import { useEffect, useState } from "react";
import { JHero } from "../components/jungle/JHero";
import { JMarquee } from "../components/jungle/JMarquee";
import { JCatalog } from "../components/jungle/JCatalog";
import { JFormats } from "../components/jungle/JFormats";
import { JKits } from "../components/jungle/JKits";
import { Assistant } from "../components/Assistant";
import { JSchedule } from "../components/jungle/JSchedule";
import { JIrrigation } from "../components/jungle/JIrrigation";
import { JPlanner } from "../components/jungle/JPlanner";
import { JLunar } from "../components/jungle/JLunar";
import { JTech } from "../components/jungle/JTech";
import { fetchProducts } from "../lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetchProducts().then(setProducts);
  }, []);
  return (
    <main data-testid="home-page">
      <JHero />
      <JMarquee />
      <JCatalog products={products} />
      <JKits kits={products.filter((p) => p.kit)} />
      <JFormats />
      <Assistant products={products.filter((p) => !p.kit)} />
      <JSchedule />
      <JPlanner />
      <JIrrigation />
      <JLunar />
      <JTech />
    </main>
  );
}
